/**
 * HTTP regex.
 */
const HTTP_REGEX: RegExp = /^http:\/\//;

/**
 * HTTPS regex.
 */
const HTTPS_REGEX: RegExp = /^https:\/\//;

export { HTTP_REGEX, HTTPS_REGEX };
